module.exports = __webpack_public_path__ + "static/media/support-Neville_Ellis.d3ce667e.jpg";